import { i18n } from '@/plugins/i18n';

export const translateError = (error_message: string) => {
  if (error_message == 'First appointment cannot be more than 2 months after prescription date'){
    return String(i18n.t('calendar.eventUpdateFailedTooEarlyAfterPrescription'))
  }
  if (error_message == 'Appointment cannot be more than 2 months after last prescription appointment'){
    return String(i18n.t('calendar.eventUpdateFailedTooLateAfterLastAppointment'))
  }
  return error_message
}

export const patientFilter = (item, queryText, _itemText) => {
  const textOne = item.first_name.toLowerCase();
  const textTwo = item.last_name.toLowerCase();
  const searchText = queryText.toLowerCase();

  return textOne.indexOf(searchText) > -1 ||
      textTwo.indexOf(searchText) > -1;
}